import axiosInstance from "../services/axiosInstance";

export const fetchHolidays = async ({
  companyId,
  page = 1,
  perPage = 10,
  search = "",
}) => {
  try {
    const response = await axiosInstance.get("console/holiday/get", {
      params: {
        company_id: companyId,
        page,
        perPage,
        search,
      },
    });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getReferences = async (companyId) => {
  try {
    const response = await axiosInstance.get("console/holiday/references", {
      params: {
        company_id: companyId,
      },
    });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const createHoliday = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/holiday/create",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const addFromReferences = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/holiday/references/add",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateHoliday = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/holiday/update",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteHoliday = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/holiday/delete",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
